import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import QuestionCenter from '@/apps/assessment/components/QuestionCenter.vue'
import RouterMixin from '@/apps/assessment/mixins/clazz-router-mixin'
import { getConfirmBooks, questionList } from '@/apps/assessment/model/api'
import { getInitInfo } from '@/apps/index/models/api'
import LabelContainer from '@/apps/question/components/LabelContainer.vue'
import LeftMenu from '@/apps/question/components/LeftMenu.vue'
import PreviewBtn from '@/apps/question/components/PreviewBtn.vue'
import QPending from '@/apps/question/components/question-pending'
import QuestionBox from '@/apps/question/components/QuestionBox.vue'
import {
  addQuestionToCart,
  removeUestionFromCart,
  updateQuestionCart
} from '@/apps/question/model/api'
import { clazzAllowUserTypes, ClazzAssessmentAllowSubjects } from '@/common/allow-list'
import { NoResult } from '@/components'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import LessInfo from '@/components/LessInfo'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import ScrollToTop from './../../index/mixins/scrollToTop'

@Component({
  components: {
    LeftMenu,
    QuestionCenter,
    LabelContainer,
    NoResult,
    PreviewBtn,
    QuestionBox,
    LessInfo,
    BasicLayout,
    QPending,
    SmallBtnSkeleton
  }
})
export default class ClazzAssessmentList extends Mixins(ScrollToTop) {
  public get subjectId() {
    console.log(this.$store.state.subject)
    return this.$store.state.subject.value
  }
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get book() {
    return this.$store.state.question.book
  }
  private get bookorkps() {
    return this.$store.state.question.bookorkps
  }
  private get singleormulti() {
    return this.$store.state.question.singleormulti
  }
  private get qTypeChoices() {
    return this.cp_question_types && this.cp_question_types[this.qClass[0]]
  }
  private get kps() {
    return this.$store.state.question.kps || []
  }
  private get catalog() {
    return this.$store.state.question.catalog
  }
  private get factors() {
    return this.$store.state.question.factors
  }
  private get textbookVersion() {
    return this.$store.state.question.textbookVersion
  }
  private get grade() {
    return this.$store.state.question.grade
  }
  private get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.questions && this.questions.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }
  // 筛选项
  public qClassChoices: any[] = []
  public cp_question_types: any = {}
  public qDifficultyChoices: any = []
  private isUnion = '1'
  private qClass = ['all', '']
  private qType = [-1, '全部']
  private qDifficulty = [-1, '全部']
  private page = 1
  private total = 0
  private sortType = 1
  private currentTitle = ''
  private hasAnalysis = false
  private questions: any[] = []
  private sum = 0 // 用于分页显示最多显示100页的数据
  private perPage = 5 // 每页显示5道题
  private loading = true
  private unMounted = true
  private optionsLoading = true

  public mounted() {
    // this.getUsableBooks()
    // this.getFilterList()
    this.getFilterList(true)
    window.addEventListener('message', (event) => {
      // console.log(event)
    })
  }
  public async getUsableBooks() {
    let data = await getConfirmBooks({ subject: 'CHINESE', level: 1, term: 1 })
  }

  @Watch('subjectId')
  public onSubjectChange(val, old) {
    if (val !== old) {
      this.qType = [-1, '全部']
      this.qClass = ['all', '']
      this.qDifficulty = [-1, '全部']
      this.currentTitle = ''
      this.hasAnalysis = false
      this.sortType = 1
      this.getFilterList(false)
    }
  }
  @Watch('userInfo')
  public onUserInfoChange(val, old) {
    // assessment页面因为需要能跳转过来，所以要在这里进行权限判断。
    if (val && clazzAllowUserTypes.indexOf(val.user_type) > -1) {
      const arr = val.subjects.filter((n) => {
        return ClazzAssessmentAllowSubjects.find((item) => item.value == n[0])
      })
      if (arr && arr.length) {
        console.log('pass')
      } else {
        this.$router.replace({ path: '/clazz/nopermission' })
      }
    } else {
      this.$router.replace({ path: '/clazz/nopermission' })
    }
  }
  @Watch('book')
  public onBookChange(val, old) {
    if (~~this.bookorkps === 2) return
    if (val === old) return
    if (!this.unMounted) {
      this.page = 1
      this.loadQuestions(this.page)
    }
  }
  @Watch('bookorkps')
  public onBookorKpsChange(val, old) {
    if (val === old) return
    if (this.unMounted) return
    console.log(22222)
    this.page = 1
    this.loadQuestions(this.page)
  }
  @Watch('singleormulti')
  public onSingleormultiChange(val, old) {
    if (val === old) return
    this.page = 1
    this.loadQuestions(this.page)
    console.log(8)
  }
  @Watch('kps')
  public onKpsChange(val) {
    if (~~this.bookorkps === 1) return
    this.page = 1
    console.log(2)
    this.loadQuestions(this.page)
  }
  @Watch('catalog')
  public onCataChange(val) {
    this.page = 1
    console.log(3)
    this.loadQuestions(this.page)
  }
  @Watch('factors')
  public onFactorsChange(val) {
    if (~~this.bookorkps === 1) return
    this.page = 1
    console.log(1)
    this.loadQuestions(this.page)
  }

  public processFactors(val) {
    let temp: any = []
    if (val && val.length) {
      for (let n of val) {
        temp = [...temp, ~~n.split('?')[0]]
      }
    }
    return temp
  }
  public unionChange(val) {
    this.isUnion = val
  }
  public async getFilterList(loadquestions?) {
    console.log(222)
    try {
      this.optionsLoading = true
      let { data, success }: any = await getInitInfo({ subject_id: this.subjectId })
      if (success) {
        // 判断是否需要类型
        if (
          data.cp_question_types &&
          data.cp_question_types.all &&
          data.cp_question_types.all.length > 0
        ) {
          this.qClassChoices = []
          this.qClass = ['all', '']
        } else {
          this.qClassChoices = [
            ['oral', '口语'],
            ['listen', '听力'],
            ['write', '笔试']
          ]
          this.qClass = this.qClassChoices[0]
        }
        Object.values(data.cp_question_types).forEach((item: any) => {
          item = item.unshift([-1, '全部'])
        })
        this.cp_question_types = data.cp_question_types
        this.qDifficultyChoices = [
          [-1, '全部'],
          ...data.question_difficulty.map((n) => {
            return n
          })
        ]
        if (data.default_book && data.default_book.length > 0) {
          this.$store.commit('SET_DEFAULTBOOK', data.default_book)
        }
        if (loadquestions) {
          this.unMounted = false
          this.loadQuestions(this.page = 1)
        }
      } else {
        // this.qTypeChoices = []
        this.qDifficultyChoices = []
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  public judgeSelected(itm, temp) {
    return itm[0] === temp[0]
  }
  public clickQClass(itm) {
    this.qClass = itm
    this.qType = [-1, '全部']
    this.page = 1
    this.loadQuestions(this.page)

    window['sensors'].track('Assessmentpage_buttonClick', { buttonName: '类型' })
  }
  public clickQtype(itm) {
    this.qType = itm
    this.page = 1
    this.loadQuestions(this.page)

    window['sensors'].track('Assessmentpage_buttonClick', { buttonName: '题型' })
  }
  public clickQdifficulty(itm) {
    this.qDifficulty = itm
    this.page = 1
    this.loadQuestions(this.page)

    window['sensors'].track('Assessmentpage_buttonClick', { buttonName: '难度' })
  }
  public onClickRanger(val) {
    this.sortType = val
    this.page = 1
    this.loadQuestions(this.page)

    window['sensors'].track('Assessmentpage_buttonClick', {
      buttonName: val == 1 ? '综合排序' : '时间排序'
    })
  }
  public onSearch(val) {
    this.page = 1
    this.loadQuestions(this.page)

    window['sensors'].track('Assessmentpage_buttonClick', {
      buttonName: '搜索'
    })
  }
  public onFilterHasAnalysis(e) {
    this.hasAnalysis = e.target.checked
    this.page = 1
    this.loadQuestions(this.page)

    window['sensors'].track('Assessmentpage_buttonClick', {
      buttonName: this.hasAnalysis ? '有解析' : ''
    })
  }
  // 题目操作
  @Watch('cartInfo', { deep: true })
  public onCartChange(val, old) {
    if (!this.unMounted) {
      this.onFlagChange(this.cartInfo, this.questions)
    }
  }
  // 全选
  public async chooseAll() {
    window['sensors'].track('Assessmentpage_buttonClick', {
      buttonName: '本页全选'
    })
    if (!this.userInfo || !this.userInfo.nickname) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    //
    let arr = [...this.cartInfo.question_ids]
    let temp: any = []
    let params: any = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subjectId,
      usage: 3
    }
    for (let n of this.questions) {
      temp = [...temp, n.id]
    }
    params.question_cart.question_ids = [...new Set([...arr, ...temp])]
    let data: any = await updateQuestionCart(params)
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
    }
  }
  public onFlagChange(data, data2) {
    let dataCopy = JSON.parse(JSON.stringify(data2))

    for (let n of dataCopy) {
      if (!data) {
        return
      }
      if (data.question_ids.findIndex((item) => (n as any).id === item) > -1) {
        n.inShoppingCart = true
      } else {
        n.inShoppingCart = false
      }
      if (n.showAnalysis) {
        n.showAnalysis = true
      } else {
        n.showAnalysis = false
      }
      if (n.is_collected) {
        n.is_collected = true
      } else {
        n.is_collected = false
      }
    }
    this.questions = dataCopy
  }
  public async cartAdd(id: number | string) {
    let data: any = await addQuestionToCart({
      question_id: id,
      subject_id: this.subjectId,
      usage: 3
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public async cartDelete(id: number | string) {
    let data: any = await removeUestionFromCart({
      question_id: id,
      subject_id: this.subjectId,
      usage: 3
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public addToCart(data) {
    if (data.val) {
      window['sensors'].track('TIKU_Assessment_organizingPaper_clk', {
        buttonName: '加入测评'
      })
      this.cartAdd(data.id)
    } else {
      this.cartDelete(data.id)
    }
  }
  public openAnalysis(item) {
    item.showAnalysis = !item.showAnalysis
  }
  public reset() {
    window.location.reload()
  }
  public onPageChange(page) {
    this.page = page
    this.loadQuestions(this.page)
    this.scrollTo(0) // 滚动到顶

    window['sensors'].track('Assessmentpage_buttonClick', {
      buttonName: '页码'
    })
  }
  // 获取题目列表
  public async loadQuestions(page, cata?) {
    let params: any = {
      subject_id: this.subjectId,
      page,
      is_ceping: 1,
      keyword: this.currentTitle,
      difficulty: Number(this.qDifficulty[0]),
      sort_type: Number(this.sortType),
      business_type: Number(this.qType[0]),
      book_catalog_id: '',
      knowledge_point_ids: [],
      kp_search_type: undefined,
      main_question_type: this.qClass && this.qClass[0],
      has_analysis: this.hasAnalysis ? 1 : 0 // 是否解析only
    }
    if (~~this.bookorkps === 2) {
      params.book_catalog_id = ''
      if (~~this.singleormulti === 2) {
        params.knowledge_point_ids = this.processFactors(this.factors.checked)
        params.kp_search_type = ~~this.isUnion || 1
      } else {
        params.knowledge_point_ids = this.processFactors(this.kps)
      }
    } else {
      params.knowledge_point_ids = []
      if (this.catalog && !cata) {
        params.book_catalog_id = this.catalog
      } else {
        params.book_catalog_id = this.book
      }
    }

    if (~~this.bookorkps === 2) {
      // 知识点
      params.book_catalog_id = this.textbookVersion
      params.grade_term = this.grade
      // params.paper_type = this.paperType
    } else {
      // 章节
      params.grade_term = undefined
      // params.paper_type = undefined
    }
    if (this.unMounted) return
    try {
      this.loading = true
      let { data, success }: any = await questionList(params)

      let kps =
        params.knowledge_point_ids && params.knowledge_point_ids.length
          ? params.knowledge_point_ids.join(',')
          : ''

      let track_param = {
        book_catalog_id: params.book_catalog_id || '',
        business_type: params.business_type || '',
        difficulty: params.difficulty,
        has_analysis: params.has_analysis,
        keyword: params.keyword || '',
        knowledge_point_ids: kps,
        kp_search_type: params.kp_search_type || '',
        page: params.page,
        region_code: params.region_code,
        sort_type: params.sort_type,
        subject_id: params.subject_id,
        total: this.total,
        main_question_type: params.main_question_type || ''
      }
      if (success) {
        this.total = data.total_count
        this.sum = data.page_count * this.perPage
        this.onFlagChange(this.cartInfo, data.questions)
        // console.log(track_param)
        setTimeout(() => {
          window['sensors'].track('Assessmentpage_loading', track_param)
        }, 200)
      } else {
        this.questions = []
        this.total = 0
        this.sum = 0
      }
    } catch (e) {
      this.questions = []
      this.total = 0
      this.sum = 0
    } finally {
      this.loading = false
    }
  }
}
